import { createTemplateJob } from '@blocksuite/affine/gfx/template';
import type { EditorHost } from '@blocksuite/affine/std';
import { GfxControllerIdentifier } from '@blocksuite/affine/std/gfx';

import { markdownToSnapshot } from '../../utils';
import { getSurfaceElementFromEditor } from '../utils/selection-utils';
import { readSlideOutline } from './outline';
import {
  basicTheme,
  type PPTDoc,
  type SlideImageSource,
  type TemplateImage,
} from './template';

export const PPTBuilder = (host: EditorHost, imageFor: SlideImageSource) => {
  const gfx = host.std.get(GfxControllerIdentifier);
  const contents: unknown[] = [];
  const allImages: TemplateImage[][] = [];

  const addDoc = async (doc: PPTDoc) => {
    const job = createTemplateJob(host.std, 'template', {
      source: 'content',
    });
    const { images, content } = await basicTheme(doc, imageFor);
    contents.push(content);
    allImages.push(images);
    if (images.length) {
      await Promise.all(
        images.map(({ id, url }) =>
          fetch(url)
            .then(res => res.blob())
            .then(blob => job.job.assets.set(id, blob))
        )
      );
    }
    await job.insertTemplate(content);
    getSurfaceElementFromEditor(host)?.refresh();
  };

  return {
    /** Builds every slide; rejects when the answer is not a valid deck. */
    process: async (text: string) => {
      const snapshot = await markdownToSnapshot(text, host.store, host);
      const docs = readSlideOutline(snapshot.snapshot?.content[0]);
      for (const doc of docs) {
        await addDoc(doc);
        gfx.fitToScreen();
      }
      return { contents, images: allImages };
    },
  };
};
